import { cn } from "@/lib/cn";

/**
 * Minimal vertical timeline. Each item is a milestone with date + title + body.
 */
export const Timeline = ({ items = [], className, testId }) => {
  return (
    <ol
      data-testid={testId || "timeline"}
      className={cn("relative flex flex-col gap-8 border-l border-border pl-8", className)}
    >
      {items.map((item, i) => (
        <li
          key={item.id || i}
          className="relative"
          data-testid={`timeline-item-${i}`}
        >
          <span
            aria-hidden="true"
            className={cn(
              "absolute -left-[33px] top-1.5 h-2.5 w-2.5 rounded-full border-2",
              item.active
                ? "border-brand bg-background"
                : "border-border bg-background"
            )}
          />
          <div className="flex flex-col gap-1.5">
            <div className="font-mono text-[11px] uppercase tracking-[0.16em] text-muted-foreground">
              {item.date}
            </div>
            <div className="text-base font-medium text-foreground">{item.title}</div>
            {item.body && (
              <p className="text-sm leading-relaxed text-muted-foreground">{item.body}</p>
            )}
          </div>
        </li>
      ))}
    </ol>
  );
};

export default Timeline;
